// extracted by mini-css-extract-plugin
export default {"wrapper":"TopFooter_wrapper__z0cwD","topFooter":"TopFooter_topFooter__YFm2t","textTitle":"TopFooter_textTitle__dtcvU","text":"TopFooter_text__1gcI3"};